import { render, staticRenderFns } from "./ChequeDisbursementCard.vue?vue&type=template&id=423e2b51&"
import script from "./ChequeDisbursementCard.vue?vue&type=script&lang=js&"
export * from "./ChequeDisbursementCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports